import { render, staticRenderFns } from "./FormTransferArticles.vue?vue&type=template&id=af4ccca0&scoped=true"
import script from "./FormTransferArticles.vue?vue&type=script&lang=js"
export * from "./FormTransferArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4ccca0",
  null
  
)

export default component.exports